import Vue from 'vue';
import App from './App.vue';

window.initDetailedSchedule = (el, { isAdmin }) => {
	new Vue({
		el,
		render: h => h(App, {
			props: {
				isAdmin,
			},
		}),
	});

	const body = $(document.body);
	$(window).on('scroll', body, () => {
		const offset = window.pageYOffset;
		if (offset) {
			body.addClass('scroll');
		} else {
			body.removeClass('scroll');
		}
	});
};
